import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "main-content"
};
const _hoisted_2 = {
  class: "carousel-section"
};
const _hoisted_3 = {
  class: "carousel-item"
};
const _hoisted_4 = {
  class: "image-skeleton"
};
const _hoisted_5 = {
  class: "image-error"
};
const _hoisted_6 = {
  class: "carousel-caption"
};
const _hoisted_7 = {
  class: "caption-title"
};
const _hoisted_8 = {
  class: "caption-text"
};
const _hoisted_9 = {
  class: "quick-access"
};
const _hoisted_10 = {
  class: "quick-access-item-box"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "text-twice-ellipsis"
};
const _hoisted_13 = {
  class: "recent-updates"
};
const _hoisted_14 = {
  class: "update-section-box"
};
const _hoisted_15 = {
  class: "update-section"
};
const _hoisted_16 = {
  key: 0,
  class: "update-list"
};
const _hoisted_17 = {
  class: "update-title text-ellipsis"
};
const _hoisted_18 = {
  class: "update-date"
};
const _hoisted_19 = {
  key: 1,
  class: "update-list"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "update-title"
};
const _hoisted_22 = {
  class: "update-date"
};
const _hoisted_23 = {
  class: "update-section"
};
const _hoisted_24 = {
  class: "update-list"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "update-title"
};
const _hoisted_27 = {
  class: "update-date"
};
import { useRouter } from 'vue-router';
import { useCourseStore } from '@/stores/courseStore';
import { useVideoStore } from '@/stores/videoStore';
import { useCategoryStore } from '@/stores/categoryStore';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'MainContent',
  setup(__props) {
    const router = useRouter();
    const courseStore = useCourseStore();
    const videoStore = useVideoStore();
    const categoryStore = useCategoryStore();
    courseStore.$subscribe((_, state) => {
      if (state.courseList.length > 0) {
        courseStore.setIsGetCourseList(true);
      }
    }, {
      deep: true
    });
    const {
      isGetCourseList
    } = storeToRefs(courseStore);
    // 轮播图数据
    const carouselItems = [{
      description: '浏览最新的医学教学课件资源',
      title: '在线培训医学教育平台',
      image: 'https://gyyyfsk.oss-cn-shenzhen.aliyuncs.com/assets/%E5%8C%BB%E9%99%A2%E5%9B%BE%E7%89%872%E8%B0%83%E8%89%B2.jpg',
      buttonText: '立即学习',
      icon: 'Document'
    }, {
      title: '在线培训医学教育平台',
      description: '浏览最新的医学教学课件资源',
      image: 'https://gyyyfsk.oss-cn-shenzhen.aliyuncs.com/assets/%E5%8C%BB%E9%99%A2%E5%9B%BE%E7%89%873.png',
      buttonText: '立即学习',
      icon: 'Document'
    }];
    const quickAccessItems = [{
      title: '教学课件',
      description: '浏览最新的医学教学课件资源',
      icon: 'Document',
      route: '/courses'
    }, {
      title: '医学视频',
      description: '查看最新的医学视频资源',
      icon: 'VideoCamera',
      route: '/courseware'
    }, {
      title: '医学图库',
      description: '丰富的医学影像资源库',
      icon: 'Picture',
      route: '/images'
    }];
    const handleQuickAccess = route => {
      router.push(route);
    };
    // 跳转课件详情
    const toCourseDetail = index => {
      courseStore.setCurrentCourse(courseStore.courseList[index]);
      const categoryName = categoryStore.categoryList.find(item => item.id === courseStore.courseList[index].categoryId)?.categoryName;
      router.push({
        name: 'CoursesDetail',
        query: {
          id: courseStore.courseList[index].id,
          categoryName: categoryName
        }
      });
    };
    // 跳转视频详情
    const toVideoDetail = item => {
      window.open(item.videoLink, '_blank');
    };
    const toCourse = route => {
      router.push(route);
    };
    return (_ctx, _cache) => {
      const _component_picture_filled = _resolveComponent("picture-filled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_carousel, {
        interval: 4000,
        height: "480px"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(carouselItems, item => {
          return _createVNode(_component_el_carousel_item, {
            key: item
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_image, {
              class: "carousel-image",
              src: item.image,
              fit: "cover",
              alt: "轮播图"
            }, {
              placeholder: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
                size: 40
              }, {
                default: _withCtx(() => [_createVNode(_component_picture_filled)]),
                _: 1
              })])]),
              error: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_icon, {
                size: 30
              }, {
                default: _withCtx(() => [_createVNode(_component_picture_filled)]),
                _: 1
              }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "加载失败", -1))])]),
              _: 2
            }, 1032, ["src"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("h3", _hoisted_7, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(item.description), 1), _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = $event => toCourse('Courses')),
              class: "caption-button"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.buttonText), 1)]),
              _: 2
            }, 1024)])])]),
            _: 2
          }, 1024);
        }), 64))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [_cache[2] || (_cache[2] = _createElementVNode("h2", {
        class: "section-title"
      }, "快速访问", -1)), _createElementVNode("div", _hoisted_10, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(quickAccessItems, (item, index) => {
        return _createElementVNode("div", {
          class: "quick-access-item",
          key: index,
          onClick: $event => handleQuickAccess(item.route)
        }, [_createVNode(_component_el_icon, {
          class: "quick-icon"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))]),
          _: 2
        }, 1024), _createElementVNode("h3", null, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_12, _toDisplayString(item.description), 1)], 8, _hoisted_11);
      }), 64))])]), _createElementVNode("div", _hoisted_13, [_cache[5] || (_cache[5] = _createElementVNode("h2", {
        class: "section-title"
      }, "最近更新", -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[3] || (_cache[3] = _createElementVNode("h3", null, "最新课件", -1)), !_unref(isGetCourseList) ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, i => {
        return _createElementVNode("li", {
          key: i
        }, [_createElementVNode("span", _hoisted_17, "内科诊断学课件 " + _toDisplayString(i), 1), _createElementVNode("span", _hoisted_18, " 2025-03-" + _toDisplayString(i.toString().padStart(2, '0')), 1)]);
      }), 64))])) : (_openBlock(), _createElementBlock("ul", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(courseStore).courseList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: item.id,
          onClick: $event => toCourseDetail(index)
        }, [_createElementVNode("span", _hoisted_21, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_22, _toDisplayString(item.createdAt.slice(0, 10)), 1)], 8, _hoisted_20);
      }), 128))]))]), _createElementVNode("div", _hoisted_23, [_cache[4] || (_cache[4] = _createElementVNode("h3", null, "最新微课", -1)), _createElementVNode("ul", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(videoStore).VideoList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: item.id,
          onClick: $event => toVideoDetail(item)
        }, [_createElementVNode("span", _hoisted_26, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_27, _toDisplayString(item.updatedAt.slice(0, 10)), 1)], 8, _hoisted_25);
      }), 128))])])])])]);
    };
  }
});